jQuery(document).ready(function($) {

    /* Flex Video
    ------------------------------*/

    // Adds Responsive Embed to YouTube and Vimeo Embeds
    jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
        if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
            jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
        } else {
            jQuery(this).wrap("<div class='responsive-embed'/>");
        }
    });

    /* Fancy Box
    ------------------------------*/

    $('.gallery').each(function() {
        $(this).find(".gallery-icon a").attr('data-fancybox', 'images');
       /* var caption = $(this).find(".gallery-caption").html();
        $(this).find(".gallery-icon a").attr('data-caption', caption);*/
    });

    $().fancybox({
      selector : '[data-fancybox="images"]',
      loop     : true
    });

    /* Flickity
    ------------------------------*/

    $('.flickity').flickity({
     // options
       cellAlign: 'left',
       wrapAround: true,
       cellSelector: '.flickity-slide',
       pageDots: false,
       arrowShape: 'M69.2,95c0.641,0.64,1.441,0.961,2.32,0.961S73.2,95.64,73.841,95c1.277-1.281,1.277-3.36,0-4.641L33.04,49.559L73.841,8.762c1.277-1.282,1.277-3.364,0-4.641c-1.281-1.281-3.359-1.281-4.641,0L26.001,47.238c-1.281,1.281-1.281,3.363,0,4.641L69.2,95z M69.2,95'
       //groupCells: true
     });

    /* Smooth Scrolling
    ------------------------------*/

    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
          && 
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 1000, function() {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              };
            });
          }
        }
      });
      /* Back to Top 
      ------------------------------*/
      $(window).scroll(function() {
          if ($(this).scrollTop() >= 50) {    // If page is scrolled more than 50px
              $('#backToTop').fadeIn();    // Fade in the arrow
          } else {
              $('#backToTop').fadeOut();   // Else fade out the arrow
          }
      });
      $('#backToTop').click(function() {      // When arrow is clicked
          $('body,html').animate({
              scrollTop : 0                  // Scroll to top of body
          }, 500);
      });
});